import { defaultFormAddress, ukraineOption } from '../../constants';
import { TRelatedCompanies } from '~/modules/identification/forms/RelatedCompanies/types.ts';

export const SEPARATE_UNITS = [
  { value: '1', label: 'Філія' },
  { value: '2', label: 'Представництво' },
  { value: '3', label: 'Дочірні компанії' },
  { value: '4', label: 'Відділення' },
  { value: '5', label: 'Інші відокремлені підрозділи' },
];

export const optionToEntityMap = {
  option0: 'Не підпорядкований корпоративній структурі',
  option1: 'Материнську компанію',
  option2: 'Управляючу компанію',
  option3: "Інше об'єднання, членом якого є юридична особа",
  option4: 'Корпорацію, холдингову групу',
  option5: 'Промислово-фінансову групу',
};

export const EMPTY_SEPARATE_UNIT = {
  fullName: null,
  identificationNumber: null,
  residenceCountry: ukraineOption,
  unitRegistrationDate: null,
  address: defaultFormAddress,
  separateUnitType: null,
};

export const testDataRelatedCompanies: TRelatedCompanies = {
  isSeparateUnitsAbsent: false,
  separateUnits: [
    {
      fullName: 'Тарас Григорович Шевченко',
      identificationNumber: null,
      residenceCountry: ukraineOption,
      unitRegistrationDate: '12.08.2024',
      address: {
        registrationAddress: {
          address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
          country: ukraineOption,
          postalCode: '12345',
          region: { value: '26', label: 'м.Київ' },
          district: null,
          city: { label: 'м.Київ', value: '191919' },
          street: { label: 'вул. Хрещатик', value: '25979' },
          houseNumber: '22',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        permanentAddress: {
          address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
          country: ukraineOption,
          postalCode: '12345',
          region: { value: '26', label: 'м.Київ' },
          district: null,
          city: { label: 'м.Київ', value: '191919' },
          street: { label: 'вул. Хрещатик', value: '25979' },
          houseNumber: '22',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        coincidences: true,
      },
      separateUnitType: { value: '4', label: 'Відділення' },
    },
  ],
  relatedEntityInfo: {
    entity: 'Управляючу компанію',
    fullName: 'Тарас Григорович Шевченко',
    residenceCountry: ukraineOption,
    identificationNumber: '12345678',
    address: {
      registrationAddress: {
        address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
        country: ukraineOption,
        postalCode: '12345',
        region: { value: '26', label: 'м.Київ' },
        district: null,
        city: { label: 'м.Київ', value: '191919' },
        street: { label: 'вул. Хрещатик', value: '25979' },
        houseNumber: '22',
        building: null,
        apartment: null,
        codeAddress: 'UA80000000000093317',
      },
      permanentAddress: {
        address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
        country: ukraineOption,
        postalCode: '12345',
        region: { value: '26', label: 'м.Київ' },
        district: null,
        city: { label: 'м.Київ', value: '191919' },
        street: { label: 'вул. Хрещатик', value: '25979' },
        houseNumber: '22',
        building: null,
        apartment: null,
        codeAddress: 'UA80000000000093317',
      },
      coincidences: true,
    },
  },
};
